import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DisclaimerWidget } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import { useTenantInfoData } from '../api/portalGateway/tenantInfo';
import { useGlobalError } from '../hooks/useGlobalError';
import { useStore } from '../store';

import styles from './login.module.scss';

export function Disclaimer() {
  const { data: tenantInfo } = useTenantInfoData();
  const disclaimer = tenantInfo.disclaimer;

  const [logoutSession, session, storedUserDisclaimerVersion, refreshSession] =
    useStore(
      useShallow((state) => [
        state.logoutSession,
        state.session,
        state.getDisclaimerVersion(),
        state.refreshSession,
      ])
    );

  const [userDisclaimerVersion, setUserDisclaimerVersion] = useState<
    number | null
  >(storedUserDisclaimerVersion);

  const setGlobalError = useGlobalError();

  const onAccept = useCallback(async () => {
    if (disclaimer?.version != null) {
      try {
        await session?.acceptDisclaimer(disclaimer?.version);
        await refreshSession(false);
        // set state to re-render component, store update doesn't
        setUserDisclaimerVersion(disclaimer?.version ?? null);
      } catch (e: unknown) {
        setGlobalError(e);
      }
    }
  }, [session, disclaimer?.version, setGlobalError, refreshSession]);

  if (disclaimer != null && userDisclaimerVersion !== disclaimer.version) {
    return (
      <div className={styles['login__root']}>
        <DisclaimerWidget
          title={disclaimer.title}
          content={disclaimer.content}
          onAccept={() => onAccept()}
          onCancel={() => logoutSession({ initiatedByUser: true })}
        />
      </div>
    );
  }
  return <Outlet />;
}
